import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'
import CTAButton from '../../../components/CTAButton.js'
import HorizontalScrollSlider from '../../../components/HorizontalScrollSlider.js'
import BackButton from '../../../components/MainComponents.js'

import { motion } from "framer-motion";

import './ServiceMedia.css'
import './MServiceMedia.css'
import { boxvar1, boxvar2, boxvar2_1, boxvar2_2, boxvar2_3, boxvar2dyndelay, boxvar4, oPU, oP } from '../../../core.js'
// import { } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import example_econlauf from '../../../assets/pictures/sectionimages/example_econlauf.webp'
import example_tereex from '../../../assets/pictures/sectionimages/example_tereex.webp'
import example_warehouserave from '../../../assets/pictures/sectionimages/example_warehouserave.webp'

var slides = [
    { img: example_warehouserave, caption: "", description: "", bg: "var(--ci_color_tilebg)" },
    { img: example_tereex, caption: "", description: "", bg: "var(--ci_color_tilebg)" },
    { img: example_econlauf, caption: "", description: "", bg: "var(--ci_color_tilebg)" },

];

const CANONICAL = 'https://tonetwork.de/services/photos'


export default function ServiceMedia() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"services"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>ToN - Media</title>
                <meta property="og:title" content="Media und Content" />
                <meta property="og:description" content="Deine starke Marke noch stärker mit passenden Fotos und Video-Content auf Socialmedia" />
                <meta name="description" content="Deine starke Marke noch stärker mit passenden Fotos und Video-Content auf Socialmedia" />

                {/* canonical */}
                <link rel="canonical" href={CANONICAL} />
                <meta property="og:url" content={CANONICAL} />
                {/* --------- */}

            </Helmet>
            <section className='sec_next' id='sec_next--service-ai'>
                <div className='sec_next_cont' id="sec_next--service-ai--cont" style={{ wordBreak: "break-word" }}>
                    <BackButton href='/services' />


                    <motion.div variants={boxvar2_1} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br />
                        <h2>Deine Marke im besten Licht.</h2>
                        <h3>Professionelle Photos und zeitgemäßer Socialmedia Content.</h3>
                        <p>
                            Mach dein Unternehmen bekannter denn je!
                        </p>
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt beraten lassen"} onclick={() => { oPU('https://calendly.com/tonetworkde-meet/getintouch') }}></CTAButton>

                    </motion.div>


                    <br /><br />

                    <motion.div variants={boxvar2_1} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br />
                        <h2>Unser Portfolio</h2>
                        <p>Bilder sagen mehr als Tausend Worte. </p>

                        {/* <motion.div variants={boxvar4} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}> */}

                        <div onClick={() => { oP('https://www.picdrop.com/tonetwork/ton-portfolio-gesamt-2026') }}> <HorizontalScrollSlider slides={slides} /></div>

                        {/* </motion.div> */}
                        <p>
                            Weit über 10 Jahre Erfahrung im Bereich Fotografie und Video-Content lassen sich wortwörtlich sehen.<br />
                            David Heidl ist seit vielen Jahren unter dem Namen <strong>davidfilmt</strong> bekannt und hat auch privat <strong>immer</strong> eine Kamera dabei,<br />
                            egal ob Party, Messe oder auch im Ehrenamt für's THW Memmingen.<br />
                        </p>
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Entdecke unser Portfolio"} onclick={() => { oP('https://www.picdrop.com/tonetwork/ton-portfolio-gesamt-2026') }}></CTAButton>

                    </motion.div>


                    <br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Unsere Leistungen</h2>
                        <ul>
                            <li>Eventfotos und Aftermovies</li>
                            <li>Individueller Socialmedia Content für Firmen</li>
                            <li>Kampagnen zur Mitarbeiterwerbung oder Produktvermarktung</li>
                            <li>Unterstützung für Influencer (Schnitt, Kamera, Licht)</li>
                        </ul>
                    </motion.div>

                    <br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Warum wir?</h2>
                        <ul>
                            <li>Wir bieten dir einen Rundum-Service, damit du dich entsptannt auf dein Business konzentrieren kannst. Das reicht von Appdesign, AI-Entwicklung bis hin zu Content-Creation</li>
                            <li>Wir stehen dir auch nach Abschluss des Projekts als langjähriger Partner zur Seite</li>
                            <li>Best Practices = Our Practices</li>
                            <li>Unsere Leistungen sind unabhängig von der Größe deines Projekts</li>
                        </ul>

                    </motion.div>

                    <br /><br /><br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Was kostet das?</h2>
                        <p>
                            Eine transparente Preisübersicht findest du auf unserer Preise-Seite. Alle dort genannten Beträge sind <b>Listenpreise ohne Rabatte</b> und werden individuell auf dein Projekt zugeschnitten.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Zu den Preisen"} href={'/pricing'}></CTAButton>
                    </motion.div>

                    <br /><br /><br /><br />

                    <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                        <div className='small_services_textbox'>
                            <h3>&lt;Individuelle Entwicklung und Beratung/&gt;</h3>
                            <br /><br />
                            <p>
                                Du bist bei unseren Leistungen nicht fündig geworden? Wir sind offen für Herausforderungen 😉<br />
                                Wir stehen dir mit Expertise zur Seite und entwickeln bspw. ein Branding für deine Marke, eine Elektronikkomponente oder eine individuelle Softwarelösung für dich.
                            </p>
                            <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt anfragen"} href={'/support'}></CTAButton>
                        </div>
                    </motion.div>

                    <br /><br /><br /><br />
                </div>
            </section >

            <MainFooter />
        </div >
    )
}